import { createSelector } from '@ngrx/store';
import * as fromFeature from '@app/auth/store/reducers';
import * as fromUser from '@app/auth/store/reducers/user.reducers';

export const selectUserState = createSelector(
  fromFeature.selectAuthFeatureState,
  (state: fromFeature.State) => state.profile
);

export const getUser = createSelector(selectUserState, fromUser.getUser);

export const getUserId = createSelector(selectUserState, fromUser.getUserId);

export const getUserRoles = createSelector(
  selectUserState,
  fromUser.getUserRoles
);

export const getConfirmationEmail = createSelector(
  selectUserState,
  fromUser.getConfirmationEmail
);

export const getRolesLoaded = createSelector(
  selectUserState,
  fromUser.getRolesLoaded
);
